import { sqConditionRuntimeStore } from '@/core/core.stores';
import type { ITEM_TYPES } from '@/trendData/trendData.constants';

/**
 * Overlays the condition's monitors so readers see them alongside its config. Conditions with no
 * entry are returned as-is (identity preserved).
 */
export function withConditionMonitors<T extends { id: string; itemType: ITEM_TYPES.CONDITION }>(item: T): T {
  const monitors = sqConditionRuntimeStore.getState().monitors[item.id];
  return monitors ? { ...item, ...monitors } : item;
}
